<template>
  <admin-layout isLayout="ideas">
    <IdeaHeader
      isLayout="ideas"
      title="Taslak INVENDO Fikirlerim"
      :subTitle="subTitle"
    />
    <div
      v-if="getDraftInvendoData.length > 0"
      style="margin: 50px 15px"
      class="ideas-table-wrapper"
    >
      <vue-good-table
        class="admin-table"
        :columns="columns"
        :rows="getDraftInvendoData"
        :line-numbers="true"
      >
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field == 'action'">
            <button
              class="btn-innovation-radius bg-blue-2 px-4 py-2"
              data-toggle="modal"
              data-target="#modal-idea-detail"
              @click.stop="tableEdit(props.row)"
            >
              Düzenle
            </button>
            <button
              class="btn-innovation-radius bg-red-1 px-4 py-2"
              data-toggle="modal"
              data-target="#modal-idea-detail"
              @click.stop="deleteCardShowModal(props.row)"
            >
              Sil
            </button>
          </div>
          <div
            v-else-if="
              props.column.field == 'CreatedOnUtc' ||
              props.column.field == 'SuggestionDate'
            "
          >
            {{
              props.formattedRow[props.column.field] | newDateFormatterFilter
            }}
          </div>
          <div v-else>
            {{ props.formattedRow[props.column.field] }}
          </div></template
        >
      </vue-good-table>

      <div class="row mt-4 d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRecords"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
    <NotIdea v-else /><transition name="fade">
      <InvendoIdeas
        v-if="isShareInvendo"
        @close="isShareInvendo = $event"
        :editData="editData"
        :isDraft="true"
      />
    </transition>
    <transition name="fade">
      <CardDelete
        v-if="isCardDelete"
        @close="isCardDelete = $event"
        @delete="tableDelete"
        :isSuggestion="false"
      />
    </transition>
  </admin-layout>
</template>

<script>
import { mapGetters } from "vuex";

import { suggestionInvendoService, upload } from "../../services";
import { fileTypeCheck, newDateFormatter } from "../../helpers";

import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import IdeaHeader from "../../components/MyIdea/IdeaHeader.vue";
import AdminLayout from "../../layouts/AdminLayout.vue";
import NotIdea from "../../components/MyIdea/NotIdea.vue";
import InvendoIdeas from "../../components/Modals/InvendoIdeas.vue";
import CardDelete from "../../components/Main/Cards/Modals/CardDelete.vue";
export default {
  name: "DraftInvendo",
  data() {
    return {
      perPage: 15,
      currentPage: 1,
      columns: [
        {
          label: "Fikir Tarihi",
          field: "SuggestionDate",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Sorun/Fırsat",
          field: "Problem",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "FİKİR",
          field: "SuggestionDetail",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Değer Akımı",
          field: "ValueCurrentName",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Statü",
          field: "SuggestionStatusName",
          sortable: false,
          thClass: "vgt-center-align",
        },
        {
          label: "",
          field: "action",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
      ],
      editData: null,
      isShareInvendo: false,
      cardDeleteDataId: null,
      isCardDelete: false,
      subTitle:
        "Taslak olarak kaydettiğiniz tüm INVENDO fikirlerinizi burada listeyebilirsiniz.",
    };
  },
  components: {
    VueGoodTable,
    AdminLayout,
    NotIdea,
    InvendoIdeas,
    CardDelete,
    IdeaHeader
  },
  filters: {
    newDateFormatterFilter(value) {
      return newDateFormatter(value);
    },
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
    getDraftInvendoData() {
      return this.$store.getters["draft/getDraftInvendoData"];
    },
    totalRecords() {
      return this.$store.getters["draft/getDraftInvendoTotalRecords"];
    },
  },
  async created() {
    if (this.getDraftInvendoData.length == 0) {
      this.getData();
    }
  },
  methods: {
    async getData() {
      const body = {
        pageIndex: this.currentPage - 1,
        pageSize: this.perPage,
        suggestionStatuses: [11],
        createdUserId: this.user.Data.UserId,
        loginUserId: this.user.Data.UserId,
      };
      await this.$store.dispatch("draft/setDraftInvendoData", body);
    },
    async tableEdit(item) {
      this.$store.dispatch("loading/setIsLoading", true);
      const tmpData = item;
      if (item.FileId != null) {
        const res = await upload.fetchDownloadFile(item.FileId);
        tmpData.DownloadFile = {
          DownloadBinary: res.Data.DownloadBinary,
          Extension: res.Data.Extension,
          Filename: res.Data.Filename,
          Id: res.Data.Id,
          fileType: fileTypeCheck(res.Data.Extension),
        };
      }
      this.editData = tmpData;
      this.$store.dispatch("loading/setIsLoading", false);
      this.isShareInvendo = true;
    },
    deleteCardShowModal(item) {
      this.cardDeleteDataId = item.Id;
      this.isCardDelete = true;
    },
    async tableDelete() {
      try {
        const res = await suggestionInvendoService.fetchDeleteSuggestionInvendo(
          this.cardDeleteDataId
        );
        if (res.Success) {
          this.$toast.success("İşleminiz başarıyla tamamlandı.", {
            position: "top",
          });
          this.$store.dispatch("draft/deleteDraftInvendoData");
          const body = {
            pageIndex: 0,
            pageSize: 15,
            suggestionStatuses: [11],
            createdUserId: this.user.Data.UserId,
            loginUserId: this.user.Data.UserId,
          };
          this.$store.dispatch("draft/setDraftInvendoData", body);
        } else {
          this.$toast.error("İşleminiz sırasında bir hata oluştu.", {
            position: "top",
          });
        }
      } catch (error) {
        this.$toast.error("İşleminiz sırasında bir hata oluştu.", {
          position: "top",
        });
      }
    },
  },
};
</script>